import { render, staticRenderFns } from "./BaseQuillEditor.vue?vue&type=template&id=f50039a6"
import script from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
export * from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
import style0 from "./BaseQuillEditor.vue?vue&type=style&index=0&id=f50039a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports